var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import * as CreativeUtils from '../utils/CreativeUtils';
const LocalCreative = (_a) => {
    var { id, size, defaultLanguage, language, resolvePath } = _a, rest = __rest(_a, ["id", "size", "defaultLanguage", "language", "resolvePath"]);
    const [creative, setCreative] = React.useState();
    const mounted = React.useRef(true);
    React.useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    React.useEffect(() => {
        CreativeUtils.loadLocalCreative(id, size, language, defaultLanguage, resolvePath).then(creative => {
            if (creative && mounted.current) {
                setCreative(creative);
            }
        });
    }, [id, size, language, defaultLanguage, resolvePath, mounted]);
    if (creative) {
        return React.createElement("img", Object.assign({ loading: "lazy", src: creative, alt: `${size} ${language}` }, rest));
    }
    else {
        return null;
    }
};
export default LocalCreative;
//# sourceMappingURL=LocalCreative.js.map